import { TransactionTitle } from '~/components/component-library/TransactionTitle'
import { TransactionIcon } from '~/components/smart-accounts/TransactionIcon'
import { BackendTransaction } from '~/types'

export const TransactionHeader = ({
  transaction,
  showIcon,
}: {
  transaction: BackendTransaction
  showIcon?: boolean
}) => {
  return (
    <>
      {showIcon && (
        <div className="-mb-2 flex">
          <TransactionIcon transaction={transaction} size="lg" />
        </div>
      )}
      <div className="mt-2 w-full">
        <TransactionTitle
          transaction={transaction}
          className="w-full flex-grow text-wrap break-words text-left text-lg font-medium"
          textWrap
        />
      </div>
    </>
  )
}
